import fetch from '@/helpers/fetch';

export default {
	state: {
		unfoldingsList: null,
	},
	mutations: {
		SET_UNFOLDINGS_LIST(state, unfoldings) {
			state.unfoldingsList = unfoldings;
		},
	},
	actions: {
		fetchUnfoldings: async function(context): Promise<object[]> {
			const data = await fetch.get('/api/trials');
			context.commit('SET_UNFOLDINGS_LIST', data);
			return data;
		},
	},
};
